import { useEffect } from "react";
import HomeNav from "@/components/home/HomeNav";
import HomeHero from "@/components/home/HomeHero";
import HomeBlocks from "@/components/home/HomeBlocks";
import HomeFooter from "@/components/home/HomeFooter";

export default function Home() {
  useEffect(() => {
    document.title = "AC Investing";
    const m = document.querySelector('meta[name="description"]');
    if (m) m.setAttribute("content", "Comprendre où se déplace la valeur. MULTIPOLAR et OPENACCESS.");
  }, []);

  return (
    <main data-testid="home-page" className="relative">
      <HomeNav />
      <HomeHero />
      <HomeBlocks />
      <HomeFooter />
    </main>
  );
}
